import React from "react";

type Props = {
  className?: string;
  placeholder?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  name?: string;
  id?: string;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  autoComplete?: string;
  maxLength?: number;
  minLength?: number;
  title?: string;
  readOnly?: boolean;
  cols?: number;
  rows?: number;
  wrap?: string;
  form?: string;
};

const TextArea = ({
  className,
  placeholder,
  value,
  onChange,
  name,
  id,
  required,
  disabled,
  autoFocus,
  autoComplete,
  maxLength,
  minLength,
  title,
  readOnly,
  cols,
  rows,
  wrap,
  form,
}: Props) => {
  return (
    <textarea
      className={`
            bg-white border border-gray-300 rounded-2xl py-2 px-3
            ${className}`}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      name={name}
      id={id}
      required={required}
      disabled={disabled}
      autoFocus={autoFocus}
      autoComplete={autoComplete}
      maxLength={maxLength}
      minLength={minLength}
      title={title}
      readOnly={readOnly}
      cols={cols}
      rows={rows}
      wrap={wrap}
      form={form}
    />
  );
};

export default TextArea;
